
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{staticClass:"line",attrs:{"d":"M36.775 11.937L26.452 1.233A.751.751 0 0025.909 1H4.842C2.72 1.002 1.003 2.785 1 4.983v15.034C1 22.217 2.72 24 4.842 24h21.067c.204 0 .399-.084.543-.233l10.323-10.704c.3-.31.3-.815 0-1.126z","stroke":"#000","stroke-width":"2"}}),_c('path',{staticClass:"dot",attrs:{"d":"M25.975 14.975a3.5 3.5 0 11-4.95-4.948 3.5 3.5 0 014.95 4.948","fill":"#000"}})])])
          )
        }
      }
    